import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ToggleResponse } from './+state/feature-toggle.models';

@Injectable()
export abstract class FeatureToggleRepository {
  abstract getCurrentUserToggles(): Observable<ToggleResponse>;
}
